class LoadingIndicatorIcon {

	constructor() {
		'ngInject';
	}
}

export default LoadingIndicatorIcon;

